export const NOTIFICATION_SWITCH_DELAY_MS = 500;
export const VR_WIZARD_READ_STORAGE_KEY = "VR_WIZARD_READ";
